import { render } from "./UserListItemUser.vue?vue&type=template&id=4287d3f0&scoped=true"
import script from "./UserListItemUser.vue?vue&type=script&lang=js"
export * from "./UserListItemUser.vue?vue&type=script&lang=js"

import "./UserListItemUser.vue?vue&type=style&index=0&id=4287d3f0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4287d3f0"]])

export default __exports__